import React from 'react';
import SignIn from './Data';


function Login() {
    return (
        <div>
<SignIn />
        </div>
    );
}

export default Login;
